import { render } from "./Index.vue?vue&type=template&id=57784735&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=57784735&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57784735"],['__file',"components/Pages/BookFacility/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57784735"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57784735', __exports__)) {
    api.reload('57784735', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=57784735&scoped=true", () => {
    api.rerender('57784735', render)
  })

}


export default __exports__